import * as React from 'react';
import type { FC } from 'react';

import { Tag, Typography2 } from '@coursera/cds-core';
import { SuccessFilledIcon } from '@coursera/cds-icons';

import { TermStatus } from 'bundles/degree-home/components/v3-dpm/components/PlanningTool/lib/academicTermTypes';

import _t from 'i18n!nls/degree-home';

type Props = {
  termStatus: TermStatus;
};

const TermStatusTag: FC<Props> = ({ termStatus }) => {
  switch (termStatus) {
    case TermStatus.COMPLETE:
      return (
        <Tag variant="status" priority="primary" color="success" icon={<SuccessFilledIcon />}>
          {_t('Complete')}
        </Tag>
      );
    case TermStatus.IN_PROGRESS:
      return (
        <Tag variant="status" priority="primary" color="highlight1">
          {_t('In progress')}
        </Tag>
      );
    case TermStatus.NOT_STARTED:
      return (
        <Typography2 component="p" variant="bodyPrimary">
          {_t('Not started')}
        </Typography2>
      );
    default:
      return null;
  }
};

export default TermStatusTag;
